import { FeatureToggle } from '../types';
import { normalizeFeatures } from './normalize';
var featuresFromBackend = [{
  id: 'salescrm-id',
  name: 'СrmSales',
  type: FeatureToggle.Features.CrmSales,
  enabled: true
}, {
  id: 'interactions-id',
  name: 'CrmInteractions',
  type: FeatureToggle.Features.CrmInteractions,
  enabled: true
}, {
  id: 'interactions-id',
  name: 'TrendAnalysis',
  type: FeatureToggle.Features.TrendAnalysis,
  enabled: false
}, {
  id: 'feature-drilldown',
  name: 'Drilldown',
  type: FeatureToggle.Features.Drilldown,
  enabled: false
}];
export var fetchAvailableFeatures = function fetchAvailableFeatures() {
  return new Promise(function (resolve) {
    return setTimeout(function () {
      return resolve(normalizeFeatures(featuresFromBackend));
    }, 10);
  });
}; // TODO: load available features from backend
//  Raven.captureException(error, { extra: 'Error loading available features' });
// axios.get(`/api/analytics/reports/available-features`).catch(axios.onError);